// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  isMockEnabled: true, // You have to switch this, when your real back-end is done
  authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
  usa: {
    apiKey: 'AIzaSyB8NWGxzoPjMEn5hSeqywN5JoQOrM-g8tk',
    authDomain: 'esense-20ba5.firebaseapp.com',
    databaseURL: 'https://esense-20ba5.firebaseio.com',
    projectId: 'esense-20ba5',
    storageBucket: 'esense-20ba5.appspot.com',
    messagingSenderId: '156391288415',
    appId: '1:156391288415:web:a1240df65120a4f680b5ea',
    measurementId: 'G-MFTMD6H39H',
  },
  europe: {
    apiKey: 'AIzaSyB8NWGxzoPjMEn5hSeqywN5JoQOrM-g8tk',
    authDomain: 'esense-20ba5.firebaseapp.com',
    databaseURL: 'https://esense-europe.europe-west1.firebasedatabase.app',
    projectId: 'esense-20ba5',
    storageBucket: 'esense-20ba5.appspot.com',
    messagingSenderId: '156391288415',
    appId: '1:156391288415:web:a1240df65120a4f680b5ea',
    measurementId: 'G-MFTMD6H39H',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
